import { Field, TextOutput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { createWashingSieveSizeCaptionSelector } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import { Phase, StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { hasValue } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { PortionSievingDetailsSection, PortionSievingEquipmentSection, PortionSievingRecordGridSection } from '..';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';

let PortionSievingSection: React.FC<IWorksheetComponent> = ({ namePrefix, createWorksheetSelector }) => {
  const isCoarsePortionSieving = namePrefix?.endsWith('CoarsePortion');

  const isFinePortionSieving = namePrefix?.endsWith('FinePortion.Subspecimen');

  const washingSieveSizeCaption = useSelector(createWashingSieveSizeCaptionSelector(createWorksheetSelector!));

  const rootPath = namePrefix?.substr(0, namePrefix?.lastIndexOf('.WholePortion'));
  const parentPath = namePrefix?.substr(0, namePrefix?.lastIndexOf('.'));

  const isFinePortionDry = useSelector(
    pipe(
      createWorksheetSelector!(`${parentPath}.FinePortion.Preparation.StateAfterInitialPreparation`, false),
      (s: StateOfMaterial) => s === StateOfMaterial.OvenDry
    )
  );

  const haveWashingsBeenTaken = useSelector(
    pipe(
      createWorksheetSelector!(`${rootPath}.Preparation.WashingPhase`, false),
      (p: Phase) => !hasValue(p) || p !== Phase.Never
    )
  );

  return (
    <>
      <PortionSievingDetailsSection />
      <NamePrefixModifier appendNamePrefix="Sieving">
        <PortionSievingEquipmentSection />
        <PortionSievingRecordGridSection isCoarsePortionOfSeparationDuringSieving={isCoarsePortionSieving!} />
      </NamePrefixModifier>
      {isCoarsePortionSieving && (
        <ListFieldSection>
          <NamePrefixModifier namePrefix={parentPath}>
            <Field
              input={<TextOutput />}
              label={`Expected Passing Mass`}
              name={`FinePortion.Masses.${isFinePortionDry ? 'DryMass' : 'WetMass'}`}
            />
          </NamePrefixModifier>
        </ListFieldSection>
      )}
      {/* Show upscaled % of washings in the fine portion sieving section a
      as this includes */}
      {isFinePortionSieving && haveWashingsBeenTaken && (
        <NamePrefixModifier namePrefix={rootPath}>
          <ListFieldSection>
            <Field
              input={<TextOutput />}
              label={`Passing ${washingSieveSizeCaption} from Wash (%)`}
              name="Results.PercentagePassingWashingSieve"
            />
          </ListFieldSection>
        </NamePrefixModifier>
      )}
    </>
  );
};

PortionSievingSection = withInjectedProps(PortionSievingSection);

export { PortionSievingSection };
export default PortionSievingSection;
